import { render } from "./EditarSedes.vue?vue&type=template&id=783281e6&scoped=true"
import script from "./EditarSedes.vue?vue&type=script&lang=js"
export * from "./EditarSedes.vue?vue&type=script&lang=js"

import "./EditarSedes.vue?vue&type=style&index=0&id=783281e6&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783281e6"]])

export default __exports__